import { useAppSelector } from "stores";

export const useAuthStore = () => {
  const orgSelected = useAppSelector((state) => state?.auth.orgSelected);

  return {
    orgSelected,
  };
};
